import React, { useEffect } from 'react';
import { Button, HeroTitle, HeroText } from '@cof/gravity-react';
import DepositSummary from '../DepositSummary/DepositSummary';

import { formatDepositDueDate } from '../../utils/formatDueDate';
import { general, confirmationPageStrings } from '../../strings';

import './ConfirmationPage.scss';

const ConfirmationPage = ({ activeLanguage, potomacLoaded, pageData }) => {
    document.title = 'Deposit Confirmation'

    const srn = pageData.srn;
    useEffect(() => {
        if (potomacLoaded) {
            console.log('Sending pageView event for Deposit Confirmation');
            window.sp(
                'trackPageView', 
                'v2 - Deposit Confirmation',
                [{
                    schema: 'iglu:com.capitalone.snowplow/application/jsonschema/1-0-4',
                    data: {
                        'applicationId': srn
                    }
                }]
            );
        }
    }, [potomacLoaded, srn]);

    const remaining = pageData.minimumDepositAmount - (pageData.depositHistoryTotal + (pageData.depositAmount * 1));
    const cardFunded = remaining <= 0;
    const dueDate = formatDepositDueDate(pageData.depositDueDate);

    const isMobile = window.matchMedia('(max-width: 800px)').matches;

    return (
        <div className="confirmation-page">
            {!cardFunded && <HeroTitle className="remaining-box">${remaining}<br></br>{confirmationPageStrings[activeLanguage].Remaining}</HeroTitle>}
            <HeroTitle className="confirmation-text" size="medium">{cardFunded ? confirmationPageStrings[activeLanguage].Congratulations : confirmationPageStrings[activeLanguage].AlmostThere}</HeroTitle>
            <HeroText className="confirmation-text">{
                cardFunded ?
                    confirmationPageStrings[activeLanguage].FullyFunded :
                    `${confirmationPageStrings[activeLanguage].PartiallyFunded}$${remaining}${confirmationPageStrings[activeLanguage].PartiallyFunded2}${dueDate.toLocaleDateString(activeLanguage + '-us')}${confirmationPageStrings[activeLanguage].PartiallyFunded3}`
            }</HeroText>
            <br></br><br></br>
            <DepositSummary pageData={pageData} activeLanguage={activeLanguage} confirmationNum={pageData.transactionReferenceNumber} />
            {!isMobile &&
                <div className="printLink">
                    <Button href="" type="text" onClick={() => window.print()}>{general[activeLanguage].Print}</Button>
                </div>
            }
        </div>
    )
}

export default ConfirmationPage;
